import { createAsyncThunk } from "@reduxjs/toolkit";

const API_BASE = process.env.REACT_APP_API_BASE;

export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async (data, thunkAPI) => {
    try {
      const body = JSON.stringify(data);
      const res = await fetch(`${API_BASE}/api/auth/app/login`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "x-user-role": "partner",
        },
        body: body,
      });

      if (res.status === 401) {
        thunkAPI.dispatch(logoutUser());
        const currentUrl = window.location.href;
        const authUrl = `${process.env.REACT_APP_AUTH_BASE_URL}?redirect=${encodeURIComponent(currentUrl)}`;
        window.location.href = authUrl;
        return thunkAPI.rejectWithValue("Unauthorized");
      }
      const json = await res.json();

      // ✅ API error (non-2xx status)
      if (!res.ok) {
        throw new Error(json?.message || "Login failed");
      }

      // ✅ Reject vendor accounts
      if (json?.user?.account_type === "vendor") {
        return thunkAPI.rejectWithValue(
          "Vendor accounts are not allowed to log in."
        );
      }

      // ✅ Success
      return json;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message || "Login failed");
    }
  }
);

export const forgotPassword = createAsyncThunk(
  "auth/forgotPassword",
  async (data, thunkAPI) => {
    try {
      const body = JSON.stringify(data);
      const res = await fetch(`${API_BASE}/api/auth/app/forgot-password`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "x-user-role": "partner",
        },
        body: body,
      });

      if (res.status === 401) {
        thunkAPI.dispatch(logoutUser());
        const currentUrl = window.location.href;
        const authUrl = `${process.env.REACT_APP_AUTH_BASE_URL}?redirect=${encodeURIComponent(currentUrl)}`;
        window.location.href = authUrl;
        return thunkAPI.rejectWithValue("Unauthorized");
      }
      const json = await res.json();

      if (!res.ok) {
        throw new Error(json?.message || "Login failed");
      }

      return json;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message || "Login failed");
    }
  }
);

export const SetupNewPassword = createAsyncThunk(
  "auth/SetupNewPassword",
  async (data, thunkAPI) => {
    try {
      const body = JSON.stringify(data);
      const res = await fetch(`${API_BASE}/api/auth/app/reset-password-token`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "x-user-role": "partner",
        },
        body: body,
      });

      if (res.status === 401) {
        thunkAPI.dispatch(logoutUser());
        const currentUrl = window.location.href;
        const authUrl = `${process.env.REACT_APP_AUTH_BASE_URL}?redirect=${encodeURIComponent(currentUrl)}`;
        window.location.href = authUrl;
        return thunkAPI.rejectWithValue("Unauthorized");
      }
      const json = await res.json();

      if (!res.ok) {
        throw new Error(json?.message || "Login failed");
      }

      return json;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message || "Login failed");
    }
  }
);
export const SetupMemberPassword = createAsyncThunk(
  "auth/SetupMemberPassword",
  async (data, thunkAPI) => {
    try {
      const body = JSON.stringify(data);
      const res = await fetch(`${API_BASE}/api/auth/app/setup-password`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "x-user-role": "partner",
        },
        body: body,
      });

      const json = await res.json();

      if (!res.ok) {
        throw new Error(json?.message || "Login failed");
      }

      return json;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message || "Login failed");
    }
  }
);

export const ResetNewPassword = createAsyncThunk(
  "auth/ResetNewPassword",
  async (data, thunkAPI) => {
    try {
      const body = JSON.stringify(data);
      const res = await fetch(`${API_BASE}/api/auth/app/reset-password-token`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "x-user-role": "partner",
        },
        body: body,
      });

      if (res.status === 401) {
        thunkAPI.dispatch(logoutUser());
        const currentUrl = window.location.href;
        const authUrl = `${process.env.REACT_APP_AUTH_BASE_URL}?redirect=${encodeURIComponent(currentUrl)}`;
        window.location.href = authUrl;
        return thunkAPI.rejectWithValue("Unauthorized");
      }
      const json = await res.json();

      if (!res.ok) {
        throw new Error(json?.message || "Login failed");
      }

      return json;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message || "Reset failed");
    }
  }
);

export const verifyTwoFactorCode = createAsyncThunk(
  "auth/verifyTwoFactorCode",
  async (data, thunkAPI) => {
    try {
      const body = JSON.stringify(data);
      const res = await fetch(
        `${API_BASE}/api/auth/app/verify-two-factor-code`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            "x-user-role": "partner",
          },
          body: body,
        }
      );

      const json = await res.json();

      if (!res.ok) {
        throw new Error(json?.message || "Login failed");
      }

      return json;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message || "Login failed");
    }
  }
);

export const logoutUser = createAsyncThunk(
  "auth/logoutUser",
  async (_, { rejectWithValue }) => {
    try {
      const res = await fetch(`${API_BASE}/api/auth/app/logout`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "x-user-role": "partner",
        },
      });

      const json = await res.json();

      if (!res.ok) {
        return rejectWithValue(json?.message || "Logout failed");
      }

      return json; // success message or status
    } catch (err) {
      return rejectWithValue(err.message || "Unexpected error during logout");
    }
  }
);

export const ResetPasswordToken = createAsyncThunk(
  "auth/ResetPasswordToken",
  async (data, thunkAPI) => {
    try {
      const body = JSON.stringify(data);
      const res = await fetch(`${API_BASE}/api/auth/app/reset-password-token`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "x-user-role": "partner",
        },
        body: body,
      });

      const json = await res.json();

      if (!res.ok) {
        throw new Error(json?.message || "Login failed");
      }

      return json;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message || "Login failed");
    }
  }
);

export const checkAuthStatus = createAsyncThunk(
  "auth/checkStatus",
  async (_, { rejectWithValue }) => {
    try {
      const res = await fetch(`${API_BASE}/api/auth/app/me`, {
        method: "GET",
        credentials: "include", // include cookies
        headers: {
          "Content-Type": "application/json",
          "x-user-role": "partner",
        },
      });

      const json = await res.json();

      if (!res.ok) {
        return rejectWithValue(json.message || "Not authenticated");
      }

      return json; // e.g., user data
    } catch (err) {
      return rejectWithValue(err.message || "Auth check failed");
    }
  }
);
